import React from 'react'
import TablePage from '../../../../../components/pages/TablePage'
import moment from 'moment'

export default () => {
    const columns = [
        {
            selector: (row) => row?.id,
            name: 'Id',
            wrap: true,
        },
        {
            selector: (row) => row?.cmd,
            name: 'CMD',
            wrap: true,
        },
        {
            selector: (row) => row?.status,
            name: 'Status',
            wrap: true,
        },
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY HH:mm')) || '-',
            name: "CreatedAt",
            id: 'createdAt'
        }
    ]
    return (
        <TablePage
            title={"Jobs"}
            url="api/v1/job"
            actionPosition={'first'}
            columns={columns}
        />
    )
}